//
// Usage: 
//  import const from '@app/const'
//
import clsConst from '@/app/clsConst'

let obj = new clsConst();

export default obj;